var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9365 13.7695C25.9365 13.7695 22.3156 21 14.5 21C6.68438 21 3.06353 13.7695 3.06353 13.7695C2.97882 13.601 2.97882 13.399 3.06353 13.2305C3.06353 13.2305 6.68438 6 14.5 6C22.3156 6 25.9365 13.2305 25.9365 13.2305C26.0212 13.399 26.0212 13.601 25.9365 13.7695ZM14.5 8.30772C11.78 8.30772 9.5715 10.6344 9.5715 13.5C9.5715 16.3655 11.78 18.6922 14.5 18.6922C17.22 18.6922 19.4285 16.3655 19.4285 13.5C19.4285 10.6344 17.22 8.30772 14.5 8.30772Z",
    fill: "#43927C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.55,
    cy: 13.55,
    r: 2.75,
    fill: "#43927C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.292e145afad32ec88194d59bfff82ca0.svg";
export { ForwardRef as ReactComponent };